const statsContent = {
  label: 'Stats Settings',
  name: 'stats',
  component: 'group',
  fields: [
    {
      label: 'Stats',
      name: 'statItems',
      component: 'group-list',
      itemProps: {
        label: '{{item.title}}',
      },
      fields: [
        {
          label: 'Ttile',
          name: 'title',
          component: 'text',
        },
        {
          label: 'Number',
          name: 'number',
          component: 'text',
        },
      ],
    },
  ],
};

export const Schema = () => ({
  label: 'Environment',
  category: 'Content',
  key: 'environment',
  previewSrc:
    'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.45.29_20AM.png?v=1684864554',
  fields: [
    {
      label: 'Heading',
      name: 'heading',
      component: 'text',
      defaultValue: 'Our Environmental Impact',
    },
    {
      label: 'Color Heading',
      name: 'colorHeading',
      component: 'text',
      defaultValue: 'Every Sip Counts',
    },
    {
      label: 'Eyebrow',
      name: 'eyebrow',
      component: 'text',
      defaultValue: 'About the Problem',
    },

    {
      label: 'Copy',
      name: 'copy',
      component: 'text',
      defaultValue:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    {
      label: 'Image',
      name: 'image',
      component: 'image',
    },
    statsContent,
  ],
});
